import { GET_PT_JOINING_URL_TELEV2 } from './constants';

type Response = {
    guest_url: string | null;
    error?: string;
    redirect: boolean;
};

export default (aid: string): Promise<Response> =>
    fetch(GET_PT_JOINING_URL_TELEV2(aid)).then(async (r) => {
        if (r.ok) {
            return await r.json();
        } else {
            const err = new Error('Failed to fetch guest_url') as Error & { status: number };
            err.status = r.status;
            throw err;
        }
    });
